<div class="input-file" [class.file-error]="!valid">
  <div class="text_info">
    <span class="input-file__label">{{ dokumentArtLabel }}</span>
    <div class="info" *ngIf="dokumentArt === dokumentArten.Antrag || dokumentArt === dokumentArten.Sonstige ? false : true ">
      <div class="info_trigger icon--before icon--info" *ngIf="(dokumentArtInfo | async) as res" (click)="popupService.openInfoPopup(res)"></div>
    </div>
  </div>
  <div class="input-file__files files-uploaded" *ngIf="uploadedFiles.length">
    <div *ngIf="uploadedFiles.length <= anzahlFilesExpansion; else filesUploadedExpansion">
      <ng-container [ngTemplateOutlet]="uploadedFilesContentTemplate"></ng-container>
    </div>
    <ng-template #filesUploadedExpansion>
      <mat-accordion>
        <mat-expansion-panel [expanded]="true">
          <mat-expansion-panel-header>
            <ng-container [ngTemplateOutlet]="uploadedFilesHeaderTemplate"></ng-container>
          </mat-expansion-panel-header>
          <ng-container [ngTemplateOutlet]="uploadedFilesContentTemplate"></ng-container>
        </mat-expansion-panel>
      </mat-accordion>
    </ng-template>
  </div>
  <div class="input-file__files files-added" *ngIf="addedFiles.length">
    <div *ngIf="addedFiles.length <= anzahlFilesExpansion; else filesAddedExpansion">
      <ng-container [ngTemplateOutlet]="addedFilesHeaderTemplate"></ng-container>
      <ng-container [ngTemplateOutlet]="addedFilesContentTemplate"></ng-container>
    </div>
    <ng-template #filesAddedExpansion>
      <mat-accordion>
        <mat-expansion-panel [expanded]="true">
          <mat-expansion-panel-header>
            <ng-container [ngTemplateOutlet]="addedFilesHeaderTemplate"></ng-container>
          </mat-expansion-panel-header>
          <ng-container [ngTemplateOutlet]="addedFilesContentTemplate"></ng-container>
        </mat-expansion-panel>
      </mat-accordion>
    </ng-template>
  </div>
  <ng-template #uploadedFilesHeaderTemplate>
    <p><strong>Diese {{ uploadedFiles.length > 1 ? 'Dateien wurden' : 'Datei wurde' }} übermittelt</strong></p>
  </ng-template>
  <ng-template #uploadedFilesContentTemplate>
    <div class="files-date-group" *ngFor="let uploadedFilesDateGroup of uploadedFilesDateGroups | keyvalue">
      <p><strong> {{ uploadedFiles.length <= anzahlFilesExpansion ? 'Diese ' + (uploadedFilesDateGroup.value.length > 1 ? 'Dateien wurden' : 'Datei wurde') + ' bereits am ' + (uploadedFilesDateGroup.key | timestampToString) + ' übermittelt' : 'Übermittelt am ' + (uploadedFilesDateGroup.key | timestampToString) }}</strong></p>
      <ul class="list" aria-label="Hochgeladene Dateien">
        <li *ngFor="let selectedFile of uploadedFilesDateGroup.value">
          <ng-container [ngTemplateOutlet]="fileLabelTemplate" [ngTemplateOutletContext]="{ selectedFile: selectedFile }"></ng-container>
          <ng-container [ngTemplateOutlet]="fileErrorTemplate" [ngTemplateOutletContext]="{ selectedFile: selectedFile }"></ng-container>
          <div class="input-file__actions"></div>
        </li>
      </ul>
    </div>
  </ng-template>
  <ng-template #addedFilesHeaderTemplate>
    <p><strong>Diese {{ addedFiles.length > 1 ? 'Dateien werden' : 'Datei wird' }} übermittelt</strong></p>
  </ng-template>
  <ng-template #addedFilesContentTemplate>
    <ul class="list" aria-label="Hochzuladende Dateien">
      <li *ngFor="let selectedFile of addedFiles">
        <ng-container [ngTemplateOutlet]="fileLabelTemplate" [ngTemplateOutletContext]="{ selectedFile: selectedFile }"></ng-container>
        <ng-container [ngTemplateOutlet]="fileErrorTemplate" [ngTemplateOutletContext]="{ selectedFile: selectedFile }"></ng-container>
        <div class="input-file__actions">
          <a href="javascript:;" class="secondary icon--before icon--loschen" (click)="removeFile(selectedFile)">
            <span>Löschen</span>
          </a>
        </div>
      </li>
    </ul>
    <div class="input-file__general-actions" *ngIf="addedFiles.length > 1">
      <a href="javascript:;" class="secondary icon--before icon--loschen" (click)="removeFiles(addedFiles)">
        <span>Alle Löschen</span>
      </a>
    </div>
  </ng-template>
  <ng-template #fileLabelTemplate let-selectedFile="selectedFile">
    <div *ngIf="selectedFile.Malware; else fileInfo">
      <div class="input-file__file malwareinfo">
        <div class="file__thumbnail icon--before icon--search-document"><span><strong>{{ selectedFile.Name }}:</strong> Diese Datei konnte aus Sicherheitsgründen nicht verarbeitet werden.</span></div>
      </div>
    </div>
    <ng-template #fileInfo>
      <div class="input-file__file">
        <div class="file__thumbnail icon--before icon--search-document"><span>{{ selectedFile.Name }} ({{ selectedFile.Size / 1024  | number }} KB)</span></div>
      </div>
    </ng-template>
  </ng-template>
  <ng-template #fileErrorTemplate let-selectedFile="selectedFile">
    <div>
      <span>
        <small class="input__response icon--before icon--red icon--circle-black" *ngIf="selectedFile.Errors.get(errorFileSizeTotal)">Die Datei überschreitet das Gesamtlimit von {{ fileSizeTotalMax / 1024 / 1024 | number }} MB</small>
        <small class="input__response icon--before icon--red icon--circle-black" *ngIf="selectedFile.Errors.get(errorFileSize)">Die Datei überschreitet {{ fileSizeMax / 1024 / 1024 | number }} MB</small>
        <small class="input__response icon--before icon--red icon--circle-black" *ngIf="selectedFile.Errors.get(errorInvalidFileType)">Der Dateityp wird nicht unterstützt</small>
      </span>
    </div>
  </ng-template>
  <div *ngIf="multiple || !multiple && !uploadedFiles.length">
    <div class="input-file__dropzone" [id]="'dropzone_' + dokumentArt" appDragDrop (fileDropped)="onFileDropped($event)">
      <input [id]="'files_' + dokumentArt" [name]="'files_' + dokumentArt" type="file" [accept]="acceptedFileTypes" class="input-file__input" [attr.multiple]="multiple ? 'multiple' : null" title="" (change)="onFileSelected($event)">
      <label class="icon--before icon--search-document" [for]="'files_' + dokumentArt">
        Ziehen Sie die gewünschte Datei in die graue Fläche oder klicken Sie, um eine Datei auszuwählen
      </label>
      <button type="button" class="button button--primary">
        <span>{{ multiple && selectedFiles.length >= 1 ? 'Datei hinzufügen' : 'Datei auswählen'}}</span>
      </button>
      <div class="underline-primary">
      </div>
    </div>
    <div class="input-file__hint">
      Erlaubte Dateitypen: {{ acceptedFileExtensions }}
    </div>
    <div *ngIf="required && !selectedFiles.length && parentFormGroupDirective.submitted">
      <small class="input__response icon--before icon--red icon--circle-black">
        {{ dokumentArt === dokumentArten.Antrag ? 'Bitte einen Antrag hochladen' : 'Bitte ziehen sie eine Datei in die graue Fläche oder klicken Sie um eine Datei auszuwählen' }}
      </small>
    </div>
  </div>
</div>
